import { combineReducers } from 'redux';
import PluginSet from './plugin_set';

const rootReducer = combineReducers({
  pluginSet: PluginSet
});

export default rootReducer;
